import { MAX_REMOTE_ACTIONS_RETRY_COUNT } from '../../common/constants';
import {
	type RemoteAction,
	type RemoteActionMetas,
	type RemoteActionsMetas,
} from '../../common/types';

// Seconds cooldown between perform attempts
export const MINIMUM_TIME_BETWEEN_ATTEMPTS_SECONDS = 60;
export const isMinimumTimeBetweenAttemptsElapsed = (actionMetas: RemoteActionMetas): boolean => {
	const now = Date.now();
	const timeDiff = now - actionMetas.lastPerformAttemptedAt;

	return timeDiff > MINIMUM_TIME_BETWEEN_ATTEMPTS_SECONDS * 1000;
};

export const canRetry = (actionMetas: RemoteActionMetas): boolean =>
	actionMetas.attemptCounts < MAX_REMOTE_ACTIONS_RETRY_COUNT;

export const computeShouldPerformAction = (
	action: RemoteAction,
	metas: RemoteActionsMetas,
): boolean => {
	const actionMetas = metas[action.id];

	if (!actionMetas) {
		// No meta, we have not attempted to perform this action yet.
		return true;
	}

	if (!canRetry(actionMetas)) {
		// TODO: send a "cancelled analytics event ?"
		return false;
	}

	if (!isMinimumTimeBetweenAttemptsElapsed(actionMetas)) {
		return false;
	}

	// All the conditions are satisfied, we can perform the action.
	return true;
};
